import { ArrowLeft, House } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

type Props = {
  backLabel?: string;
  backTo?: string;
  onBack?: () => void;
  homeTo?: string;
  homeLabel?: string;
  showBackIcon?: boolean;
  className?: string;
};

const navigationItemClassName =
  "inline-flex h-10 items-center gap-2 rounded-full border px-4 text-[14px] font-medium no-underline " +
  "shadow-[0_10px_30px_rgba(15,23,42,0.06)] backdrop-blur transition-colors " +
  "hover:border-[#b8c0cc] hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c8508a]/30";

const navigationItemStyle: React.CSSProperties = {
  borderColor: "var(--brand-border, #d8dee7)",
  background: "var(--brand-surface-elevated, var(--brand-surface, rgba(255,255,255,0.9)))",
  color: "var(--brand-text-primary, #1f2937)",
};

export const PageNavigation: React.FC<Props> = ({
  backLabel,
  backTo,
  onBack,
  homeTo = "/",
  homeLabel = "На главную",
  showBackIcon = true,
  className = "",
}) => {
  const backContent = (
    <>
      {showBackIcon ? <ArrowLeft size={17} strokeWidth={2} aria-hidden="true" /> : null}
      <span>{backLabel}</span>
    </>
  );

  return (
    <nav
      className={`flex w-fit flex-wrap items-center gap-2 ${className}`.trim()}
      aria-label="Навигация по странице"
    >
      {backLabel && onBack ? (
        <button
          type="button"
          className={`${navigationItemClassName} cursor-pointer`}
          style={navigationItemStyle}
          onClick={onBack}
        >
          {backContent}
        </button>
      ) : backLabel && backTo ? (
        <Link className={navigationItemClassName} style={navigationItemStyle} to={backTo}>
          {backContent}
        </Link>
      ) : null}

      <Link className={navigationItemClassName} style={navigationItemStyle} to={homeTo}>
        <House size={17} strokeWidth={2} aria-hidden="true" />
        <span>{homeLabel}</span>
      </Link>
    </nav>
  );
};
